import { useMemo } from 'react'

import { IFsNodeSchema } from '@cloudike/web_files'
import { BoardToolbarAction } from 'shared/constants/toolbar'
import { ToolbarTop } from 'features/common/ui/dashboard/ToolbarTop'

interface BoardPageToolbarTopProps {
  selectedItems: IFsNodeSchema[]
  boardToolbarMainActions: any[]
  mixedToolbarMainActions: any[]
  assetsToolbarMainActions: any[]
  boardToolbarExtraActions: any[]
  mixedToolbarExtraActions: any[]
  assetsToolbarExtraActions: any[]
  toolbarActionsIcons: Record<string, React.ReactNode>
  onToolbarActionClick: (itemType: 'board' | 'asset' | 'mixed', actionId: string, items: any[]) => void
  onCloseToolbar: () => void
}

export const BoardPageToolbarTop = ({
  selectedItems,
  boardToolbarMainActions,
  assetsToolbarMainActions,
  mixedToolbarMainActions,
  boardToolbarExtraActions,
  assetsToolbarExtraActions,
  mixedToolbarExtraActions,
  toolbarActionsIcons,
  onToolbarActionClick,
  onCloseToolbar,
}: BoardPageToolbarTopProps) => {
  let selectedType = 'none'

  const selectedBoardsIds = selectedItems.filter(item => item.type === 'dir').map(board => board.id)
  const selectedAssetsIds = selectedItems.filter(item => item.type === 'link').map(asset => asset.id)
  
  const hasBoardsSelected = selectedBoardsIds.length > 0
  const hasAssetsSelected = selectedAssetsIds.length > 0
  const hasMixedSelection = hasBoardsSelected && hasAssetsSelected

  if (hasBoardsSelected && !hasMixedSelection) {
    selectedType = 'board'
  } else if (hasAssetsSelected && !hasMixedSelection) {
    selectedType = 'asset'
  } else if (hasMixedSelection) {
    selectedType = 'mixed'
  }

  const hasAnySelection = hasBoardsSelected || hasAssetsSelected

  const multiselectSupportedActionsLookup = useMemo(() => {
    return {
      board: [
        BoardToolbarAction.Move,
        BoardToolbarAction.Delete,
        BoardToolbarAction.Download,
        BoardToolbarAction.Duplicate
      ],
      asset: [
        BoardToolbarAction.Move,
        BoardToolbarAction.Delete,
        BoardToolbarAction.RemoveFromBoard,
        BoardToolbarAction.Download,
        BoardToolbarAction.Duplicate
      ],
      mixed: [
        BoardToolbarAction.Move,
        BoardToolbarAction.Delete,
        BoardToolbarAction.Download,
        BoardToolbarAction.Duplicate
      ]
    }
  }, [])

  const mixedMainActions =  mixedToolbarMainActions
  const mixedExtraActions = mixedToolbarExtraActions

  const toolbarExtraActionsLookup = useMemo(() => {
    return {
      board: boardToolbarExtraActions,
      asset: assetsToolbarExtraActions,
      mixed: mixedExtraActions
    }
  }, [boardToolbarExtraActions, assetsToolbarExtraActions, mixedExtraActions])

  const toolbarMainActionsLookup = useMemo(() => {
    return {
      board: boardToolbarMainActions,
      asset: assetsToolbarMainActions,
      mixed: mixedMainActions
    }
  }, [boardToolbarMainActions, assetsToolbarMainActions, mixedMainActions])
  
  return (
    <ToolbarTop
      isShown={hasAnySelection}
      itemsType={selectedType}
      mainActions={toolbarMainActionsLookup[selectedType]}
      extraActionsGroups={toolbarExtraActionsLookup[selectedType]}
      selectedItems={selectedItems}
      actionsIcons={toolbarActionsIcons}
      onActionClick={onToolbarActionClick}
      onClose={onCloseToolbar}
      multiselectSupportedActions={multiselectSupportedActionsLookup[selectedType]}
    />
  )
} 